import { Roles } from "@/models/user.model";
import { getUserFromStorage } from "@/utils/user-store.util";

export function guardTeacher(to: any, from: any, next: any) {
  if (getUserFromStorage()?.role == Roles.TEACHER) {
    next();
  } else {
    next("/sign-in");
  }
}
